import {
    HttpResponse,
    ExchangeRateModel,
    QueryModel,
    RequestParams,
    ExchangeRateModelIEnumerableApiResultSuccess,
    ExchangeRateModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ExchangeRatesDataService implements CrudService<ExchangeRateModel, ExchangeRateModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getExchangeRateGroupped(query, params);
    }
    
    getAll(query: CrudDataQuery<ExchangeRateModel>): Promise<CrudListResponse<ExchangeRateModel>> {
        return ApiService.api.getExchangeRateBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ExchangeRateModel>> {
        return ApiService.api.getExchangeRateById(id, params);
    }

    create(item: ExchangeRateModel, params?: RequestParams): Promise<CrudResponse<ExchangeRateModel>> {
        return ApiService.api.insertExchangeRate(item, params);
    }

    update(item: ExchangeRateModel, params?: RequestParams): Promise<ExchangeRateModel> {
        return ApiService.api.updateExchangeRate(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ExchangeRateModel> {
        return ApiService.api.patchExchangeRate(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ExchangeRateModel>): Promise<CrudListResponse<ExchangeRateModel>> {
        return ApiService.api.deleteExchangeRate(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ExchangeRateModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
